// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var OrdersController = function ($scope, $routeParams, Orders) {
    $scope.filter = { search: $routeParams.entityId ? $routeParams.entityId : $routeParams.customerId };

    $scope.loadOrders = function () {
        $scope.orders = $scope.paginator(function (options, callback) {
            return Orders.query(options, function () { callback(); });
        }, { searchFilter: $scope.filter.search, statusFilter: $scope.filter.status, before: $scope.filter.before }, 100);
    }

    $scope.loadOrders();
};
OrdersController.$inject = ['$scope', '$routeParams', 'Orders'];
